module.exports = __webpack_public_path__ + "img/sequence-default2.61a38cb4.png";